import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export interface ModalFailureData {
  msg: string;
  title?: string;
  buttonText?: string;
  customClass?: string;
}

@Component({
  selector: 'app-modal-failure',
  imports: [CommonModule, TranslateModule],
  templateUrl: './modal-failure.component.html',
  styleUrl: './modal-failure.component.scss'
})
export class ModalFailureComponent {
  private dialog = inject(MatDialogRef<ModalFailureData>);
  public data = inject(MAT_DIALOG_DATA);

  ngOnInit(): void {
    document.body.classList.add('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.removeAttribute('aria-hidden');
    }
  }

  ngOnDestroy() {
    document.body.classList.remove('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.setAttribute('aria-hidden', 'true');
    }
  }

  beforeClose(): boolean {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
    return false;
  }

  closeDialog(res?: any): void {
    this.beforeClose();
    this.dialog.close(res);
  }

}